export const FRUITFUL_INSTITUTION_NAME = 'Fruitful';
export const ACCOUNT_NAME_MAX_LENGTH = 20;

export enum RelationshipStatus {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
}

export enum AccountOwnership {
    INDIVIDUAL = 'individual',
    JOINT = 'joint',
}

export enum AccountType {
    CHARGE_SECURED = 'CHARGE_SECURED',
    CHARGE_UNSECURED = 'CHARGE_UNSECURED',
    CHECKING = 'CHECKING',
    GENERAL_LEDGER = 'GENERAL_LEDGER',
    LINE_OF_CREDIT = 'LINE_OF_CREDIT',
    SAVING = 'SAVING',
}
